import * as React from 'react';

import { PropertySourceDetails } from 'models';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export const PropertySource: React.FunctionComponent<PropertySourceDetails> = ({ graphic, text, accessibilityLabel }) => {
  if (!text || !text.value) {
    return null;
  }

  const { id, description, url } = graphic || {};

  return (
    <>
      <UitkLayoutFlex space="one" alignItems="end">
        <UitkLayoutFlexItem>
          <UitkText size={300} theme="default" overflow="truncate" data-stid="property-source">
            {text.value}
          </UitkText>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <>
            <UitkSpacing padding={{ blockend: 'one' }}>
              <div>
                {id && <UitkMark name={id} size={UitkMarkSize.EXTRA_SMALL} description={description} />}
                {!id && url?.value && <UitkMark url={url.value} size={UitkMarkSize.EXTRA_SMALL} description={description} />}
              </div>
            </UitkSpacing>
          </>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
      {accessibilityLabel && <UitkText className="is-visually-hidden">{accessibilityLabel}</UitkText>}
    </>
  );
};
PropertySource.displayName = 'PropertySource';
